var header4i = function() {
	var mn, header,	
	ajaxActions = (function(){
		var callWrapper,
			userLinksWrapper,
		init = function(){
			callWrapper = document.getElementsByClassName("callWaitWrapper")[0];
			userLinksWrapper = document.getElementById("userSpecificLinksBox");
		},
		loadCallStats = function() {
			if (callWrapper == null) { return; }
			fetch('/Header/CallWaitTime', { headers: { 'X-Requested-With': 'fetch' }}).then(function(response ) {
				return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function(html){
				if(html.length < 1) { return; }
				callWrapper.classList.add("hide");
	    			callWrapper.classList.remove("hideOnMedium");
	    			callWrapper.insertAdjacentHTML('afterend', html);
			});
		},
		loadUserLinks = function() {
			if (userLinksWrapper == null) { return; }
			fetch('/Header/UserSpecificLinks', { headers: { 'X-Requested-With': 'fetch' }}).then(function(response){
				return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function(html){
				if(html.length < 1) { return; }
		    		userLinksWrapper.innerHTML = html;
				headerMobileSearch.Init();
				headerAccount.Init();
				headerCart.Init();
				if(document.getElementById('callBtn')){
					headerClickToCall.Init();
				}
				if(document.getElementById('seoBtn')){
					// bootload SEO bits here only when needed
					var seo = document.createElement('script'); 
					seo.type = 'text/javascript'; 
					seo.async = true; 
					seo.src = 'https://cdna.4imprint.co.uk/qtz/views/seooverlay/seoeditor.js';
					var bodyEl = document.getElementsByTagName('body')[0]; 
					bodyEl.appendChild(seo);
				}
			});
	    	};
		return{
			Init: init,
			LoadCallStats: loadCallStats,
			LoadUserLinks: loadUserLinks
		};
	})(),
	
    	adobe = (function () {
	    	var clickToCall = function (phNum) {
	     	 	if(s){
	      		      	s.linkTrackVars="prop20,eVar20,eVar33,events"; 
	 	      		s.linkTrackEvents="event28";
		      		s.events='event28';
	            		s.eVar33= phNum;
	            		//s.v33=phNum
	            		s.prop20='D=v33';
	            		//s.c20='D=v20';
	            		s.pe='lnk_o';
	            		s.pev2='Click-to-Call';
		        	s.tl(true, 'o', 'Click-to-Call');
		        	s.linkTrackEvents='None';
		        	s.linkTrackVars='None';
	        	}
	    	};	
	    	return {
	        	ClickToCall: clickToCall
	    	};
	})(),
	
	headerClickToCall = (function(){
		var init = function(s, s_account){
    			document.getElementById('callBtn').addEventListener("click", function (e) {
            			e.preventDefault();
            			adobe.ClickToCall(this.getAttribute('data-adobe-v33'));
            			window.location.href=e.target.href;
       		});
		};
		return{
			Init: init
		};
	})(),
	
	headerMobileSearch = (function(){
		// wires up the magnifying glass icon in the menu to show or hide the search box on mobile.
		var mobileSearch,
			searchInput,
			searchBar,		
		init = function(){
			mobileSearch = document.getElementById("showMobileSearch");
			searchInput = document.getElementById("txtSearch");
			searchBar = document.getElementsByClassName("HeaderSearchBar")[0];
			if (mobileSearch !== null){
				mobileSearch.addEventListener("click", function(){				
					if(searchBar.classList.contains("show")){
						searchBar.classList.remove("show");
						searchBar.classList.add("hide");
						mobileSearch.classList.remove("bkgdLtGray");
						mobileSearch.setAttribute("aria-expanded", "false");
						mobileSearch.focus();
					}else{
						searchBar.classList.remove("hide");
						searchBar.classList.add("show");
						mobileSearch.classList.add("bkgdLtGray");
						mobileSearch.setAttribute("aria-expanded", "true");
						searchInput.focus();
					}
				});
			}	
		};
		return{
			Init: init
		};
	})(),
	
	headerAccount = (function(){
		var accountTrigger,
			accountView,
			accountLink,
			firstLink,
			accountDropLinks,
			
		init = function(){
			accountTrigger = document.getElementById("accountTrigger");
			accountView = document.getElementById("accountMenu");
			accountLink = document.getElementById("lnkAccountSummary");		
			//have to do these null checks because of the thirdparty stuff which hides the account menu
			firstLink = accountView && accountView.getElementsByTagName("a") ? accountView.getElementsByTagName("a")[0] : null;
			accountDropLinks = firstLink ? accountView.getElementsByTagName("a") : null;
			hoverintent(accountTrigger, function(){ show(); }, function(){ hide(); });
			accountKeys();
		},
		show = function(trigger, menu) {	
			accountView.classList.add("fadeIn");
			accountView.style.display = "block";
			accountLink.setAttribute("aria-expanded", "true");
			document.removeEventListener("keydown", escapeAccount);
			document.addEventListener("keydown", escapeAccount);
		},
		hide = function() {
			accountView.classList.remove("fadeIn");
			accountView.removeAttribute("style");
			accountLink.setAttribute("aria-expanded", "false");
		},
		showHide = function(){
			if(accountView.style.display == "block"){
				hide();
			}else{ 
				show(); 
				firstLink.focus();
			}
		},
		escapeAccount = function(e){
	    		if(e.keyCode === 27){ // allow user to close on escape
				hide();
	    		}
		},
		accountKeys = function(){
			if(accountLink){
				accountLink.addEventListener("keydown", function(e){
					if(e.keyCode === 13){ //enter key
						e.preventDefault();
						e.stopPropagation();
						showHide();
					}
					if(e.altKey){ // alt + down arrow to open the menu (native control for accessing content via keyboard)
					 	if(e.keyCode === 40){
					 		e.preventDefault();
							e.stopPropagation();
							showHide();
					 	}
					 }
				});
			}
			if(accountDropLinks){
				Array.prototype.forEach.call(accountDropLinks, function(el, index, array){
					el.addEventListener("keydown", function(e){
						if ([40, 38, 9].indexOf(e.keyCode) == -1) { return; } // if not up, down and tab keys end here
						var lastLink = array[array.length -1];
						var nextLink = array[index + 1];
						var prevLink = array[index - 1];
						switch(e.keyCode) {
							case 40: // down arrow
								e.preventDefault();
								e.stopPropagation();
								if(lastLink == document.activeElement){
						 			hide();
						 		}else{
						 			nextLink.focus();
						 		}
								break;
							case 38: // up arrow
								e.preventDefault();
								e.stopPropagation();
								if(accountDropLinks[0] == document.activeElement){
						 			hide();
						 		}else{
						 			prevLink.focus();
						 		}
								break;
							case 9: // tab
								e.preventDefault();
								e.stopPropagation();
								if(lastLink == document.activeElement){
						 			hide();
						 		}
						 		else {
						 			nextLink.focus();
						 		}
						}
					});
				});
			}
		};
		return{
			Init: init
		};
	})(),
	
	headerCart = (function(){
		var cartTrigger,
			cartView,
			cartSummary,
			checkoutLink,
			cartButtons,
			
		init = function(){
			cartTrigger = document.getElementById("cartTrigger");
			cartView = document.getElementsByClassName("cartsummary_view")[0];
			cartSummary = document.getElementById("lnkCartSummary");
			checkoutLink = document.getElementById("checkoutLink");	
			cartButtons = document.getElementsByClassName("cartsummary_buttons");
			hoverintent(cartTrigger, function(){ show(); },  function(){ hide(); });    
			cartKeys();
		},
		show = function() { 
			cartView.classList.add("fadeIn");
			cartView.style.display = "block";
			cartSummary.setAttribute("aria-expanded", "true");
			lazyloadImages.update();
			//lazyload4i.LoadImages();
			document.removeEventListener("keydown", escapeCart);
			document.addEventListener("keydown", escapeCart);
		},
		hide = function() {
			cartView.classList.remove("fadeIn");
			cartView.removeAttribute("style");
			cartSummary.setAttribute("aria-expanded", "false");
		},
		escapeCart = function(e){
	    		if(e.keyCode === 27){ // allow user to close on escape
				hide();
	    		}
		},
		showHide = function(){
			if(cartView.style.display == "block"){
		 		hide(); 
		 	}else{ 
		 		show();
		 		cartView.focus();
		 	}
		},
		cartKeys = function(){
			if(cartSummary){
				cartSummary.addEventListener("keydown", function(e){
					if(e.keyCode == 13){ //enter key
						e.preventDefault();
						e.stopPropagation();
					 	showHide();
					 }
					 if(e.altKey){ // alt + down arrow to open the menu (native control for accessing content via keyboard)
					 	if(e.keyCode == 40){
					 		e.preventDefault();
							e.stopPropagation();
						 	showHide();
					 	}
					 }
				});
				
				checkoutLink.addEventListener("blur", function(){
					hide(); 
				});
				Array.prototype.forEach.call(cartButtons, function(el, index, array){
					el.addEventListener("keydown", function(e){
						if ([38,40].indexOf(e.keyCode) == -1) { return; } // if not down, up keys end here
						switch(e.keyCode) {
							case 40: // down arrow
							case 38: // up arrow
								e.preventDefault();
								e.stopPropagation();
								hide(); 
						}
					});
				});
			}
		};
		return{
			Init: init
		};
	})(),
	stickyMenuBar = function(){
		if (window.scrollY > header.offsetHeight) {
			mn.classList.add("main-nav-scrolled");
		} else {
			mn.classList.remove("main-nav-scrolled");
		}
	},

	init = function(){
		mn = document.querySelector(".main-nav");
		header = document.querySelector('header');
		
		ajaxActions.Init();
		ajaxActions.LoadUserLinks();
		ajaxActions.LoadCallStats();
		window.addEventListener("scroll", stickyMenuBar);
	};
	
	return{
		Init: init,
		HeaderCart: headerCart
	};
};
(function(){
	var loadHeader = new header4i();
	loadHeader.Init();
})();